import { getUserMailboxInfo } from 'owa-client-ids';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { isOnPrimaryCalendar } from 'owa-calendar-forms-common/lib/utils/isMeetingOnSecondaryCalendar';

export default function shouldSupportAutoRoomBooking(): boolean {
    const { event } = getComposeStore();

    if (!event) {
        return false;
    }

    const emailAccount = event.ParentFolderId?.mailboxInfo.userIdentity;
    const isPrimaryAccount = emailAccount === getUserMailboxInfo().userIdentity;

    return !event.Recurrence && isPrimaryAccount && isOnPrimaryCalendar(event);
}
